// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ii_a bik_jk","CommentListPlaceholder--Legacy":"ii_b bik_rc bik_wq"};